import React from "react";
import { bool, func, string } from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";
import brandTheme from "../../../brandTheme/Theme";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const useStyles = makeStyles(() => ({
  mainContainer: {
    marginBottom: "17px",
    paddingBottom: "1.5%",
    marginTop: "10px",
  },
  button: {
    background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: brandTheme.white,
    borderRadius: "10px",
    padding: "10px 15px",
    minWidth: "140px",
    textTransform:'capitalize',
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
   
  },
  label: {
    fontSize: brandTheme.headerFontSize,
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,
    color:brandTheme.mainColor,
    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
      marginBottom: "15px",
      "&:first-child": {
        marginTop: "15px",
      },
    },
  },
  spamText :{
    fontWeight: 700,
    lineHeight: "1.5rem",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    fontFamily: brandTheme.font.poppins,
     textTransform:'capitalize'
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "right",
    fontFamily: brandTheme.font.poppins,
    paddingRight: "5%",
    gap: "15px",
    marginTop:"20px",
    "@media (max-width: 600px)": {
      justifyContent: "center",
      padding: "0px",
    },
     '& .MuiButton-root.Mui-disabled':{
      backgroundColor:brandTheme.shaddowColor,
      background:'inherit'
    }
  },
  button2: {
    minWidth: "140px",
        textTransform:'capitalize',
    backgroundColor: brandTheme.button2Color,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
}));

const BottomButton = ({
  button1,
  button2,
  disabled1,
  disabled2,
  button1click,
  button2click,
  noButton,
  cancelButtonUrl
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const status = location.state?.status || "INPROCESS";
  const { enabled } = useSelector((state) => state?.login?.adminPortalData);
  const button3click = () => {
    if(enabled){
    navigate("/AdminPortal", { state: { status: status } });
    }else if(cancelButtonUrl){
      navigate(cancelButtonUrl);
    }else{
    navigate('/Dashboard')}
  }
  return (
    <Grid item xs={12} sm={12} md={12} className={classes.mainContainer}>
      <Grid container>
        {(button1 || button2) &&
        (<Grid item xs={12} sm={12} md={12} className={classes.buttonContainer}>
          {!noButton &&
          <Button
              className={`${classes.button2} ${classes.button}`}
              disabled={disabled2}
              onClick={() => button3click()}
              id="button"
            >
              {'Cancel'}
            </Button>}
          {button1 && (
            <Button
              className={classes.button}
              disabled={disabled1}
              onClick={() => button1click()}
              id="button"
            >
              {button1}
            </Button>
          )}
          {button2 && (
            <Button
              className={`${classes.button2} ${classes.button}`}
              disabled={disabled2}
              onClick={() => button2click()}
              id="button"
            >
              {button2}
            </Button>
          )}
        </Grid>)
      }
      </Grid>
    </Grid>
  );
};

BottomButton.propTypes = {
  label: string,
  button1: string,
  button2:string,
  disabled1:bool,
  disabled2:bool,
  button1click:func,
  button2click:func,
  searchLabel:string,
  search:bool,
  onSearchChange:func,

};
export default BottomButton;
